import React, { PureComponent } from 'react';

import CountryInfo from '../CountryInfo';

const CANCELED_EVENTS_SECTION = {
    title: 'Compensation for Cancelled Events',
    content: (
        <div>
            <p>
                Du kan få kompensation, hvis du er hovedarrangør af et
                arrangement, der skulle afholdes 6. til 31. marts, men som pga.
                coronavirus/covid-19 er aflyst, væsentlig ændret eller udskudt.
                Kompensationen gives til at dække dit underskud i arrangementet.
            </p>
            <a
                href="https://indberet.virk.dk/myndigheder/stat/ERST/arrangementskompensation"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Vejledning
            </a>
        </div>
    ),
    links: [
        {
            title: 'Sådan søger du om kompensation for aflyste eller udskudte arrangementer',
            url: 'https://virksomhedsguiden.dk/erhvervsfremme/content/temaer/coronavirus_og_din_virksomhed/artikler/kompensationsordning/7ffd1f8d-fcbd-4b95-a6f1-a3e2b4b0fa92/',
        },
    ],
};

const SMB_SECTION = {
    title: 'Support for Self-Employed and Small Businesses',
    content: (
        <div>
            <p>
                40bn DKK ($6bn) in support for self-employed and small
                businesses.
            </p>
            <ul>
                <li>
                    Compensation for fixed expenses - businesses with more than
                    40% drop in revenue can have between 25 and 80% of their
                    fixed costs covered for three months.
                </li>
                <li>
                    Self-employed businesses with more thna 30% drop in revenue
                    can have up to 75% of expenses for the next three months
                    covered.
                </li>
                <li>
                    Tax deferments:
                    <a
                        href="https://skat.dk/skat.aspx?oid=16900"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://skat.dk/skat.aspx?oid=16900
                    </a>
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Lempede betalingsvilkår skal styrke likviditeten i mindre virksomheder',
            url: 'https://www.skm.dk/media/1995038/faktaark-om-lempeligere-betalingsvilkaar.pdf',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Denmark',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Denmark has multiple different financial assistance options
            available, including one specifically for cancelled events.
        </p>
    ),
    sections: [CANCELED_EVENTS_SECTION, SMB_SECTION],
};

const DenmarkInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default DenmarkInfo;
